// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".text-title_title__37uHF{\n  font-size: 14px;\n  margin-top: auto;\n}\n\n.text-title_bold__v5tV5{\n  font-weight: bold;\n}", "",{"version":3,"sources":["webpack://src/components/text-title.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;AACnB","sourcesContent":[".title{\n  font-size: 14px;\n  margin-top: auto;\n}\n\n.bold{\n  font-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"title": "text-title_title__37uHF",
	"bold": "text-title_bold__v5tV5"
};
export default ___CSS_LOADER_EXPORT___;
